import React from 'react';
import { Card, Typography, Space } from 'antd';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { TeamOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import axios from 'axios';

const { Text } = Typography;

const WorkloadChart = () => {
  const { data: workloadData, isLoading } = useQuery(
    'teamWorkload',
    () => axios.get('/daily-logs/stats', {
      params: {
        startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        endDate: new Date().toISOString().split('T')[0]
      }
    }).then(res => res.data.data),
    { refetchInterval: 60000 }
  );

  // 处理图表数据
  const chartData = workloadData?.workStats?.map(stat => ({
    name: stat.user?.realName || '未知用户',
    hours: parseFloat(stat.totalHours) || 0,
    avgHours: parseFloat(stat.avgHours) || 0
  })) || [];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          background: 'white',
          padding: '12px',
          border: '1px solid #d9d9d9',
          borderRadius: '6px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <Text strong>{label}</Text>
          <br />
          <Text>本周总工时: {payload[0].value.toFixed(1)} 小时</Text>
          <br />
          <Text>日均工时: {payload[0].payload.avgHours.toFixed(1)} 小时</Text>
        </div>
      );
    }
    return null;
  };

  return (
    <Card 
      title={
        <Space>
          <TeamOutlined />
          团队工作负荷
        </Space>
      }
      className="status-card"
      loading={isLoading}
    >
      {chartData.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Text type="secondary">暂无工作数据</Text>
        </div>
      ) : (
        <div>
          <div style={{ marginBottom: '16px' }}>
            <Text type="secondary">本周团队工作时长统计</Text>
          </div>
          
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="name" 
                tick={{ fontSize: 12 }}
                angle={-45}
                textAnchor="end"
                height={80}
              />
              <YAxis 
                tick={{ fontSize: 12 }}
                label={{ value: '工时(小时)', angle: -90, position: 'insideLeft' }}
              />
              <Tooltip content={<CustomTooltip />} />
              <Bar 
                dataKey="hours" 
                fill="#1890ff" 
                radius={[4, 4, 0, 0]}
                name="总工时"
              />
            </BarChart>
          </ResponsiveContainer>

          <div style={{ marginTop: '16px' }}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Text type="secondary">团队总工时:</Text>
                <Text strong>
                  {chartData.reduce((sum, item) => sum + item.hours, 0).toFixed(1)} 小时
                </Text>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Text type="secondary">平均工时:</Text>
                <Text strong>
                  {chartData.length > 0 
                    ? (chartData.reduce((sum, item) => sum + item.hours, 0) / chartData.length).toFixed(1)
                    : 0
                  } 小时/人
                </Text>
              </div>
            </Space>
          </div>
        </div>
      )}
    </Card>
  );
};

export default WorkloadChart;
